var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgTrash(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 24,
    height: 24,
    viewBox: "0 0 24 24",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M19 6.125V6.975C19 7.08772 18.9572 7.19582 18.881 7.27552C18.8048 7.35522 18.7015 7.4 18.5938 7.4H6.40625C6.29851 7.4 6.19517 7.35522 6.11899 7.27552C6.0428 7.19582 6 7.08772 6 6.975V6.125C6 6.01228 6.0428 5.90418 6.11899 5.82448C6.19517 5.74478 6.29851 5.7 6.40625 5.7H10.0625V4.85C10.0625 4.62457 10.1481 4.40837 10.3005 4.24896C10.4528 4.08955 10.6595 4 10.875 4H14.125C14.3405 4 14.5472 4.08955 14.6995 4.24896C14.8519 4.40837 14.9375 4.62457 14.9375 4.85V5.7H18.5938C18.7015 5.7 18.8048 5.74478 18.881 5.82448C18.9572 5.90418 19 6.01228 19 6.125ZM7.51937 19.419C7.54821 19.8489 7.73207 20.2514 8.03374 20.5449C8.33542 20.8384 8.7324 21.0011 9.14437 21H15.8719C16.2838 21.0011 16.6808 20.8384 16.9825 20.5449C17.2842 20.2514 17.468 19.8489 17.4969 19.419L18.1875 9.1H6.8125L7.51937 19.419Z"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgTrash);
export default __webpack_public_path__ + "static/media/trash.a864a494494bb27dfa0d73348461ccbf.svg";
export { ForwardRef as ReactComponent };